import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Spinner from "../../ui-components/loader-components/Spinner";
import EditorQuill from "../EditorQuill";
import { useSelector } from "react-redux";
import AlertModalContent from "../../Modals/AlertModalContent";
import Modal from "../../../common/ModalLayout";
import ClientHeaderComponent from "../../../pages/ClientPortal/components/ClientHeaderComponent";
import SwitchComponent from "../../ui-components/switch-component/SwitchComponent";
import useClientThemeHook from "../useClientThemeHook";
import { useRef } from "react";
import themePreferencesConstants from "../../../constants/client-admin-constants/clientPreferenceConstants/ClientPreferenceConstant";

const PrivacyPolicy = () => {
  const navigate = useNavigate();
  
  const [buttonClicked, setButtonClicked] = useState(false);

  const {
    updateDataFunc,
    loading,
    OpenAlertModal,
    setOpenAlertModal,
    alertContent,
    clientThemeDetail,
    setLoading,
    getClientThemeDetails,
    privacyData,
    setPrivacyData,
    privacytRef,
    resetLoading,
    setResetLoading,
  } = useClientThemeHook();

  const user = useSelector((state) => state.user);

  const handleChange = (value) => {
   
    privacytRef.current=value;
    setButtonClicked(false);
  };
  const handleChangeEnablePrivacy = (event) => {
    setPrivacyData({ ...privacyData, enablePrivacy: event.target.checked });
  };

  useEffect(() => {
    getClientThemeDetails();
  }, []);

  const submitForm = () => {
   
    setLoading(true);
    let formData = new FormData();
    formData.append("clientThemeSteps", 4);
    formData.append(
      "ClientThemeUuid",
      clientThemeDetail?.clientThemeUuid
        ? clientThemeDetail?.clientThemeUuid
        : ""
    );
    formData.append("ClientId", user?.clientDetail?.clientUuid);
    formData.append("BrandName", user?.clientDetail?.clientName);
    formData.append("PrivacypolicyHtmlString", privacytRef.current.toString());
    formData.append("ShowPrivacyPolicyPage", privacyData?.enablePrivacy);
    setPrivacyData({ ...privacyData, privacyString: privacytRef.current.toString() });
    updateDataFunc(formData);
  };


  const handleReset = () => {
    setResetLoading(true);
    let formData = new FormData();
    formData.append("clientThemeSteps", 4);
    formData.append(
      "ClientThemeUuid",
      clientThemeDetail?.clientThemeUuid
        ? clientThemeDetail?.clientThemeUuid
        : ""
    );
    formData.append("ClientId", user?.clientDetail?.clientUuid);
    formData.append("BrandName", user?.clientDetail?.clientName);
    formData.append("PrivacypolicyHtmlString", "<p><br></p>");
    formData.append("ShowPrivacyPolicyPage", privacyData?.enablePrivacy);
    setPrivacyData({ ...privacyData, privacyString: "<p><br></p>",enablePrivacy:true });
    privacytRef.current="<p><br></p>";
    updateDataFunc(formData);
  }

  return (
    <>
      <ClientHeaderComponent
        title={"Back to Preferences"}
        backLink={"/preferences"}
      />
      <div className="flex justify-between items-center mb-1">
        <h1 className="text-xl font-bold ">Privacy Policy</h1>
        <SwitchComponent
          onChange={handleChangeEnablePrivacy}
          value={privacyData?.enablePrivacy}
          id={"enableprivacy"}
        />
      </div>
      <p className="text-[#8D9D91] text-xs  mb-6">
       {themePreferencesConstants.PREFERENCES.PRIVACY_DESC}
      </p>
      <div className="mt-6">
        <EditorQuill
          toolbarId={"t2"}
          value={privacyData?.privacyString}
          onChange={handleChange}
        />

        {privacyData?.privacyString === "" && buttonClicked === true && (
          <p className="mt-1 text-xs text-red-600">
            Please write something to save.
          </p>
        )}
         <button
          onClick={handleReset}
          className={`btn-secondary mt-10 mr-3  max-w-[240px] disabled:cursor-not-allowed  px-12`}
          disabled={resetLoading}
        >
          {resetLoading && <Spinner />}
          Clear
        </button>

        <button
          onClick={submitForm}
          type="submit"
          className={`btn-primary mt-10  max-w-[240px] disabled:cursor-not-allowed  px-12`}
          data-mdb-ripple="true"
          data-mdb-ripple-color="light"
          disabled={loading}
        >
          {loading && <Spinner />}
          Save Changes
        </button>
      </div>

      {OpenAlertModal && (
        <Modal
          modalVisible={OpenAlertModal}
          closeModal={setOpenAlertModal}
          children={<AlertModalContent message={alertContent} />}
          modal_Id="Add_Modal"
          isClose={true}
        />
      )}
    </>
  );
};

export default PrivacyPolicy;
